import { Button, Icon, IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Modal } from 'native-base';
import React from 'react';
import { ActivityIndicator, Dimensions } from 'react-native';

interface ModalIncludeExcludeBlockProps {
  isModalOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  isLoading?: boolean;
}
export const ModalIncludeExcludeBlock = ({
  isModalOpen,
  onClose,
  onConfirm,
  children,
  isLoading,
}: ModalIncludeExcludeBlockProps) => {
  const { height } = Dimensions.get('window');

  return (
    <Modal isOpen={isModalOpen} onClose={onClose}>
      <Modal.Content
        alignItems="center"
        w="full"
        maxH={{ base: height * 0.75, sm: 'full' }}
        maxW={{ base: 'full', sm: '580px' }}
        marginBottom={{ base: 0, sm: 'none' }}
        marginTop={{ base: 'auto', sm: 0 }}
        borderRadius={BoxRadius.sm}>
        <VStack
          w="full"
          space={Spacing['stack.xxxs']}
          alignItems="center"
          p={{ base: Spacing['stack.xxxs'], sm: Spacing['stack.xs'] }}
          background={Color['neutral.white']}>
          <Box
            w={{ base: '55px', sm: 0 }}
            background="neutral.lightest"
            borderRadius="sm"
            h={{ base: 1, sm: 0 }}
            alignSelf="center"
          />
          <HStack w="full" justifyContent="flex-end">
            <IconButton
              testId={'icon-close'}
              icon="CloseModal"
              iconSize="xs"
              borderWidth={{ base: 0, sm: '1px' }}
              variant="rounded"
              backgroundColor="transparent"
              iconColor={Color['brand.primary.principal']}
              borderColor={Color['brand.primary.principal']}
              onPress={onClose}
              p={0}
            />
          </HStack>
          <Icon name="Warning" size="xl" color="feedback.attention.default" />
          {children}
          <VStack
            direction={{ base: 'row' }}
            alignItems={'center'}
            justifyContent={'space-between'}
            space={{ base: Spacing['stack.nano'], sm: Spacing['stack.xxxs'] }}
            zIndex={-1}>
            <Button
              variant="secondary"
              w={{ base: 'container' }}
              onPress={onClose}
              _text={{
                color: 'neutral.darkest',
                fontFamily: Typography['fontfamily.base.semibold'],
              }}>
              CANCELAR
            </Button>
            <Button
              w={{ base: 'container' }}
              variant="primary"
              onPress={onConfirm}
              _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}
              rightIcon={
                isLoading ? (
                  <VStack>
                    <ActivityIndicator color={Color['brand.tertiary.light']} />
                  </VStack>
                ) : undefined
              }>
              CONFIRMAR
            </Button>
          </VStack>
        </VStack>
      </Modal.Content>
    </Modal>
  );
};
